<template>
    <div class="products-view__list products-list products-list--grid--4" data-layout="table" data-with-features="false">
        <div class="products-list__head-check-stock">                                            
            <div class="products-list__column products-list__column--qty-check-stock head-check-stock-format">Qty</div>	 
            <div class="products-list__column products-list__column--product products-list__column--location-stock-check">Location</div>
            <div class="products-list__column products-list__column--availability"  v-if="mx_product_showStockDisplay">Availability</div>							
            <div class="products-list__column products-list__column--price products-list__column--price-stock-check">Status</div>							   
        </div>
        <div class="products-list__content">
            <available-loc-item 
                v-for="(location, indx) in locations"
                :key="location.ID"
                :index="indx"
                :location="location"
                :product="product"
                :sourcePage="'CheckStock'">
            </available-loc-item>
        </div>
    </div>

    <div class="block-space block-space--layout--divider-thin"></div>

    <div class="container">

        <div class="widget-form-panel-mobile">
            <div class="container-form-button" data-test="testing">
                <!-- <router-link to="/search-results-dms-grid-4-columns-sidebar" class="btn btn-xs btn-checkout">Order</router-link> -->
                <button class="btn btn-xs btn-grey" @click="logLostSale()" v-if="showLogLostSale">Log Lost Sale</button>
                <router-link :to="alternate_product_uri" class="btn btn-xs btn-gold">Alternate Products</router-link>
            </div>
        </div>
    </div>

    <base-dialog title="Lost Sale Confirmation" @close="closeLog" :open="logSaleOpen != false">
        <template #default>
        <p>The record of your lost sale has been <span :class='logSucessClass'>{{logMessage}}</span>.</p>
        </template>
        <template #actions>
        <button type="button" class="btn btn-sm btn-primary" @click="closeLog">
            Ok
        </button>
        </template>
    </base-dialog>

</template>

<script>
import AvailableLocItem from './AvailableLocItem.vue'
import MixinProduct from '../../../mixins/product.js';
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';

export default {
    props: {
        product: {
            type: Object,
            required: true
        },
        manufacturer: {
            type: String,
            required: true
        },
        partnumber: {
            type: String,
            required: true
        }
    },
    components : {
        AvailableLocItem
    },
    mixins : [
        MixinProduct
    ],
    data() {
        return {
            locations: [],
            logSaleOpen : false,
            logSucessClass: 'text-success',
            logMessage : null,
        };
    },
    methods: {
        stockCheck() {
            this.locations = [];
            this.isloading = true;

            axiosvl.post(this.$store.getters['api/stock_check'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer },
                        "EIMFGC": {"value": this.manufacturer },
                        "EIITMC": {"value": this.partnumber },
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields

                if (fields.RESULTCOD.value === 'OK') {
                    for (const key in response.data.webroutine.lists.SCLOC.entries) {
                        const obj = response.data.webroutine.lists.SCLOC.entries[key];
                        
                        // get the sequence from cust locations of each location got from the product
                        const sequence = this.custB2BLocations.find(loc => loc.LCLOC === obj.ILLOC);
                        
                        this.locations.push({
                            sku     : this.product.sku,
                            city    : obj.ADCITY,
                            state   : obj.ADSTTC,
                            itemnumber : obj.EIITMC,
                            manufacturer : obj.EIMFGC,
                            location_id : obj.ILLOC,
                            location : obj.LCNAME,
                            tax_city : obj.LCTAXC,
                            stockquantity : obj.LOCOH,
                            stock : obj.QOSTK,
                            eta_day : obj.QTETAD,
                            eta_mo : obj.QTETAM,
                            eta_yr : obj.QTETAY,
                            on_order : obj.QTONOR,
                            rank : obj.QTRANK,
                            STOCKEDIL : obj.STOCKEDIL,
                            quantity : 1,
                            sequence : sequence.O9SQLO,

                            XRMFGC: obj.XRMFGC,
                            XRITMC: obj.XRITMC,
                            IMIGSA: obj.IMIGSA,
                            IMISVALID: obj.IMISVALID,
                        });

                        // sort the locations by sequence
                        this.locations.sort((a,b) => (a.sequence > b.sequence) ? 1 : ((b.sequence > a.sequence) ? -1 : 0));
                    }
                    
                } else {
                    const messages = [];
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    this.$emit('show_messages', messages);
                }
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        logLostSale() {
            axiosvl.post(this.$store.getters['api/lost_log_sale'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer },
                        "EIMFGC": {"value": this.manufacturer },
                        "EIITMC": {"value": this.partnumber },
                    }
                }
            })
            .then((response) => {
                // console.log(response.data.webroutine.fields.RESULTCOD);
                const RESULTCOD = response.data.webroutine.fields.RESULTCOD.value;
                // const RESULTCOD = 'ER';
                if(RESULTCOD == 'OK'){
                    this.logSaleOpen = true;
                    this.logSucessClass = 'text-success';
                    this.logMessage  = 'logged';
                }else{
                    this.logSaleOpen = true;
                    this.logSucessClass = 'text-danger';
                    this.logMessage  = 'not logged';
                }
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        closeLog() {
            this.logSaleOpen = false;
        }
        
    },
    computed: {
        ...mapGetters([
            'storefrontAttributes',
            'custB2BLocations',
            'customerIndicator'
        ]),
        showLogLostSale() {
            if (this.storefrontAttributes.length > 0) {
                return this.storefrontAttributes.find(attribute => attribute.type === 'LLS').value === 'Y';
            } else {
                return false;
            }
        },
        alternate_product_uri(){

            return '/compare-substitutes/' + this.manufacturer + '/' + this.partnumber;
        }
    },
    created () {
        this.stockCheck();
    },
}
</script>